module.exports = __webpack_public_path__ + "media/components/images/panels/7-a-a8744c0432f9f2cbaab6c64cbbd2803f.jpeg";